import { rtkApi } from '#adapter/api/campaigns/v5/configvalues';

export const useConfigFetch = () => {
    const { data: config, error, isLoading, isFetching } = rtkApi.endpoints.getApiV5Configvalues.useQuery({});

    return {
        config,
        error,
        isLoading,
        isFetching
    };
};
